import React from 'react';
import {
  IProcessManager,
  IProcessManagerLandRegister,
} from '../../Interfaces/IProcessManager';
import { ILegalTransactionRelationship } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { ProcessManagerLandRegisterRow } from './ProcessManagerLandRegisterRow';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { ILegalClient } from '../../Interfaces/ILegalClient';

interface IProps {
  processManagerArray: IProcessManager[];
  setProcessManagerArray: Function;
  //
  relationsships: ILegalTransactionRelationship[];
  setRelationships: Function;
  //
  legalClients: ILegalClient[];
  legalPhases: ILegalPhaseFullObject[];
  legalReqStates: ILegalRequirementState[];
  //
  enableShowType?: boolean;
}

export const ProcessManagerLandRegisterTable: React.FC<IProps> = ({
  processManagerArray,
  setProcessManagerArray,
  relationsships,
  setRelationships,
  legalClients,
  legalPhases,
  legalReqStates,
  enableShowType,
}) => {
  function isProcessManagerLandRegister(
    pm: IProcessManager
  ): pm is IProcessManagerLandRegister {
    // z.B. über `idProcessManagerType` filtern
    return [10, 11].includes(pm.idProcessManagerType);
  }

  return (
    <>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell title='Automatisierungen' width={20}>
              Auto.
            </TableCell>
            {enableShowType && <TableCell>Art</TableCell>}
            <TableCell>
              Erfolgte
              <br /> Prüfungen
            </TableCell>
            <TableCell>Datum</TableCell>
            <TableCell>Gemarkung</TableCell>
            <TableCell>Blattnummer</TableCell>
            <TableCell width={90}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {processManagerArray
            .filter(isProcessManagerLandRegister)
            .map(processManager => (
              <ProcessManagerLandRegisterRow
                key={`processmanager-${processManager.idProcessManager}`}
                processManager={processManager}
                processManagerArray={processManagerArray}
                setProcessManagerArray={setProcessManagerArray}
                relationsships={relationsships}
                setRelationships={setRelationships}
                legalClients={legalClients}
                legalPhases={legalPhases}
                legalReqStates={legalReqStates}
                enableShowType={enableShowType}
              />
            ))}
        </TableBody>
      </Table>
    </>
  );
};
